const API_VER = 'v1.0'
const API_VER_V2 = 'v2.0'
export const LocationEndpoints = {
    SITE_URI: `/location/api/${API_VER}/sites/`,
    SITE_URI_V2: `/location/api/${API_VER_V2}/sites/`,
    ZONE_URI: `/location/api/${API_VER}/zones/`,
}
